import {testIdProps} from '@github-ui/test-id-props'
import {Select} from '@primer/react'
import {useCallback, useEffect} from 'react'

export type DiscussionCategoryPickerProps = {
  onSelect: (category: string) => void
  discussionCategories: DiscussionCategory[]
  categoryId?: string
}

type DiscussionCategory = {
  id: string
  name: string
}

export function DiscussionCategoryPicker({discussionCategories, onSelect, categoryId}: DiscussionCategoryPickerProps) {
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onSelect(e.currentTarget.value)
  }

  useEffect(() => {
    const firstCategory = discussionCategories?.[0]?.id
    if (firstCategory) {
      onSelect(firstCategory)
    }
  }, [discussionCategories, onSelect])

  const renderOptions = useCallback(() => {
    return discussionCategories.map((category, index) => {
      if (!category) {
        return null
      }

      return (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <Select.Option key={index} value={category.id}>
          {category.name}
        </Select.Option>
      )
    })
  }, [discussionCategories])

  return (
    <Select id={categoryId} block onChange={onChange} {...testIdProps('select')}>
      {renderOptions()}
    </Select>
  )
}
